INBOUND_TRACKING_SCARAB_VARS